/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../App_Assets/scripts/watchuslive/watchuslive.module';
import * as i2 from '../../../../App_Assets/scripts/watchuslive/watchuslive.component';
import * as i3 from './watchuslive.component.ngfactory';
import * as i4 from '@angular/common';
import * as i5 from '@angular/platform-browser';
import * as i6 from '@angular/forms';
import * as i7 from '@angular/http';
import * as i8 from '../../../../App_Assets/scripts/watchuslive/translate/translate.service';
import * as i9 from '../../../../App_Assets/scripts/watchuslive/translate/translations';
import * as i10 from '../../../../App_Assets/scripts/utility/utility.module';
export const WatchUsLiveModuleNgFactory:i0.NgModuleFactory<i1.WatchUsLiveModule> = i0.ɵcmf(i1.WatchUsLiveModule,
    [i2.WatchUsLive],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.WatchUsLiveNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i4.NgLocalization,
              i4.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
              i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
              i0.ɵl,([] as any[])),i0.ɵmpd(4608,i5.DomSanitizer,i5.ɵe,[i4.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i5.DomSanitizer]),i0.ɵmpd(4608,
              i5.HAMMER_GESTURE_CONFIG,i5.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i5.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i5.ɵDomEventsPlugin(p0_0),new i5.ɵKeyEventsPlugin(p1_0),
                    new i5.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i4.DOCUMENT,i4.DOCUMENT,i4.DOCUMENT,i5.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i5.EventManager,i5.EventManager,[i5.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i5.ɵDomSharedStylesHost,i5.ɵDomSharedStylesHost,[i4.DOCUMENT]),
          i0.ɵmpd(4608,i5.ɵDomRendererFactory2,i5.ɵDomRendererFactory2,[i5.EventManager,
              i5.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i5.ɵDomRendererFactory2]),i0.ɵmpd(6144,i5.ɵSharedStylesHost,(null as any),
              [i5.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i5.Meta,i5.Meta,[i4.DOCUMENT]),i0.ɵmpd(4608,
              i5.Title,i5.Title,[i4.DOCUMENT]),i0.ɵmpd(4608,i6.ɵi,i6.ɵi,([] as any[])),
          i0.ɵmpd(4608,i7.BrowserXhr,i7.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i7.ResponseOptions,
              i7.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i7.XSRFStrategy,i7.ɵb,
              ([] as any[])),i0.ɵmpd(4608,i7.XHRBackend,i7.XHRBackend,[i7.BrowserXhr,
              i7.ResponseOptions,i7.XSRFStrategy]),i0.ɵmpd(4608,i7.RequestOptions,
              i7.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i7.Http,i7.ɵc,[i7.XHRBackend,
              i7.RequestOptions]),i0.ɵmpd(4608,i6.FormBuilder,i6.FormBuilder,([] as any[])),
          i0.ɵmpd(4608,i8.TranslateService,i8.TranslateService,[i9.TRANSLATIONS]),
          i0.ɵmpd(512,i4.CommonModule,i4.CommonModule,([] as any[])),i0.ɵmpd(1024,
              i0.ErrorHandler,i5.ɵa,([] as any[])),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any) => {
                return [i5.ɵc(p0_0,p0_1)];
              },[[2,i5.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i5.BrowserModule,i5.BrowserModule,[[3,i5.BrowserModule]]),i0.ɵmpd(512,
              i6.ɵba,i6.ɵba,([] as any[])),i0.ɵmpd(512,i6.FormsModule,i6.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i7.HttpModule,i7.HttpModule,([] as any[])),
          i0.ɵmpd(512,i6.ReactiveFormsModule,i6.ReactiveFormsModule,([] as any[])),
          i0.ɵmpd(512,i10.UtilityModule,i10.UtilityModule,([] as any[])),i0.ɵmpd(512,
              i1.WatchUsLiveModule,i1.WatchUsLiveModule,([] as any[])),i0.ɵmpd(256,
              i9.TRANSLATIONS,i9.dictionary,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovQXp1cmVEZXZPcHNBZ2VudC9fd29yay8zL3MvVFNDLldlYi5XZWJGYWN0b3J5L0FwcF9Bc3NldHMvc2NyaXB0cy93YXRjaHVzbGl2ZS93YXRjaHVzbGl2ZS5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovQXp1cmVEZXZPcHNBZ2VudC9fd29yay8zL3MvVFNDLldlYi5XZWJGYWN0b3J5L0FwcF9Bc3NldHMvc2NyaXB0cy93YXRjaHVzbGl2ZS93YXRjaHVzbGl2ZS5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/compiled/App_Assets/scripts/watchuslive/watchuslive.module.ngfactory.ts